<script lang="typescript">
  import { service } from './store';
  import Meeting from './Meeting.svelte';
  import type { Day } from './customer-calendar-types';
  const send = $service.send;
  const closeDay = () => send('close_day');
  export let day:Day;
  $: onlyOneMeeting = day.meetings.length == 1;
</script>

<div class="day">
  <div class="day-header">
    <h2>{day.weekday_long} {day.formatted}</h2>
    <div class="close" on:click={closeDay}>
      <i class="fas fa-3x fa-window-close"></i>
    </div>
  </div>
  <div class="meetings">
    {#each day.meetings as meeting}
      <Meeting {meeting} {onlyOneMeeting}></Meeting>
    {/each}
  </div>
</div>

<style>

  .day-header {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: flex-start;
  }

  .close {
    cursor: pointer;
  }

  .meetings {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

</style>

